/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { set } from 'lodash'

import { API } from '../api/api'
import { fetch } from '../api/httpClient'
import { isEmpty } from '../helpers/utils'

export const fetchSubmissions = (tenant, id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.SUBMISSIONS}/${tenant}/${id}`
    const { data } = await fetch(url)
    modifyEasyGraderItem(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

const modifyEasyGraderItem = function (item) {
  if (isEmpty(item)) {
    return
  }
  if (item?.plagiarism?.sources?.length) {
    set(
      item,
      'plagiarism.similarLines',
      item?.plagiarism?.sources?.flatMap((source) =>
        source?.similar_lines?.map((line) => ({ url: source.url, line }))
      )
    )
  }
}
